// extracted by mini-css-extract-plugin
export default {"card":"kZ-z","carouselContainer":"lZ-z","carouselContent":"mZ-z"};